import React, { useState, useContext } from "react";
import { useParams, NavLink, useHistory } from "react-router-dom";
import { AppLoad } from "../../../core/AppLoad";
import { AppConfig, AppStateContext } from "../../../app-state";
import { getEventUrl } from "../../common/event/EventHelper";
import { Icon } from "../../../core/Icon";
import { SubmitButton } from "../../../core/SubmitButton";
export const RemoveEvent = () => {
    const { state, dispatch } = useContext(AppStateContext);
    // const [submitErrors, setSubmitErrors] = useState([]);
    const [loadState, setLoadState] = useState('idle'); //idle | loadingEdit | submitting
    const [eventData, setEventData] = useState({});
    const [removalType, setRemovalType] = useState('cancel');
    const history = useHistory();
    const { urlEventId } = useParams();
    const TryRemove = () => {
        if (loadState == 'cancelling' || loadState == 'removing')
            return;
        setLoadState('submitting');
        AppLoad(AppConfig.APIUrl + 'admin/event-management/remove', { eventId: urlEventId, remtype: removalType }).then((Response) => {
            if (Response.status == 'error') {
                alert(Response.message);
            }
            else if (Response.status == 'ok') {
                setLoadState('saved');
                history.push("/cs/sekce/sprava-aukci");
            }
        });
    };
    // const TryCancel = () => {
    //     if (loadState == 'cancelling' || loadState == 'removing') return;
    //     setLoadState('cancelling');
    //     AppLoad(
    //         AppConfig.APIUrl + 'admin/event/cancel',
    //         { eventId: urlEventId },
    //     ).then((Response: ISubmitResponse) => {
    //         if (Response.status == 'error') {
    //             alert(Response.message);
    //         } else if (Response.status == 'ok') {
    //             setLoadState('saved');
    //         }
    //     });
    // }
    return (React.createElement(React.Fragment, null,
        urlEventId && React.createElement("div", { className: "navbar" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "navbar-inner" },
                    React.createElement(NavLink, { to: getEventUrl({ id: urlEventId }), className: "back-link" },
                        React.createElement("span", { className: "icon", "aria-hidden": true }),
                        React.createElement("span", { className: "text" }, "Zp\u011Bt detail aukce"))))),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "process-master-form" }, loadState == 'saved' ?
                React.createElement(React.Fragment, null,
                    React.createElement(Icon, { c: ['tick-circle', 64, 64, 'success-icon'] }),
                    React.createElement("p", null,
                        React.createElement("b", null, "P\u0159ihl\u00E1\u0161en\u00ED prob\u011Bhlo \u00FAsp\u011B\u0161n\u011B.")),
                    React.createElement(NavLink, { to: "/cs/seznam/moje-aukce", className: "primary-button" },
                        React.createElement("span", { className: "text" }, "Zobrazit moje aukce")))
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("h1", { className: "mb-8" }, "Operace odstran\u011Bn\u00ED aukce"),
                        React.createElement("p", null, "Lze aplikovat dva zp\u016Fsoby odstran\u011Bn\u00ED. "),
                        React.createElement("table", { className: "plain-table mb-32" },
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("input", { id: "ri1", type: "radio", value: "remove", name: "remtype", defaultChecked: false, onChange: () => setRemovalType('remove') })),
                                React.createElement("td", { className: "" },
                                    React.createElement("label", { htmlFor: "ri1" }, "Provede \u00FApln\u00E9 odstran\u011Bn\u00ED aukce ze syst\u00E9mu. Tuto akci nelze vz\u00EDt zp\u011Bt."))),
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("input", { id: "ri2", type: "radio", value: "cancel", name: "remtype", defaultChecked: true, onChange: () => setRemovalType('cancel') })),
                                React.createElement("td", { className: "" },
                                    React.createElement("label", { htmlFor: "ri2" }, "Ozna\u010D\u00ED aukci jako zru\u0161enou, tzn. aukce m\u016F\u017Ee b\u00FDt ponech\u00E1na jako publikovan\u00E1 a \u00FA\u010Dastn\u00EDci se tak dozv\u011Bd\u00ED, \u017Ee aukce byla zru\u0161ena a nebude zah\u00E1jena.")))),
                        React.createElement(SubmitButton, { loadState: loadState, onClick: () => TryRemove(), label: "Prov\u00E9st" }))))));
};
